module.exports = __webpack_public_path__ + "img/surat-list-penduduk-min.175ea296.png";